import { styled } from '@olxeu-jobs/ui';
import { Platform } from '~types';

const GAP = 8;

export const CarouselWrapper = styled('section', () => ({
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
}));

export const CarouselOffsetWrapper = styled('div', ({ $theme }) => ({
  marginRight: $theme.platform === Platform.MOBILE ? 0 : `-${$theme.space[GAP]}`,
}));

export const CarouselList = styled('ul', ({ $theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowY: 'hidden',
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'none',
  gap: $theme.space[GAP],
  paddingLeft: 0,
  marginTop: 0,
  marginBottom: 0,
  userSelect: 'none',
  listStyle: 'none',
  '-webkit-overflow-scrolling': 'touch',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  ...($theme.platform === Platform.DESKTOP && {
    overflowX: 'hidden',
  }),
}));

export const CarouselListItem = styled<'li', { $itemWidthPercent: number }>(
  'li',
  ({ $itemWidthPercent }) => ({
    width: `calc(${$itemWidthPercent}% - ${GAP}px)`,
    flex: '0 0 auto',
    scrollSnapAlign: 'start',
    scrollSnapStop: 'always',
  }),
);

export const DotList = styled('ul', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: $theme.space[8],
  listStyle: 'none',
  padding: 0,
}));

export const DotListItem = styled('li', () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const DotButton = styled<'button', { $active: boolean }>(
  'button',
  ({ $active, $theme }) => ({
    width: '8px',
    aspectRatio: 1,
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%',
    borderColor: $theme.colors['icon-global-secondary'],
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    transition: `all ${$theme.animation.duration[150]}`,
    cursor: 'pointer',
    ...($active && {
      cursor: 'default',
      borderColor: $theme.colors['icon-brand-primary'],
      outline: `3px solid ${$theme.colors['icon-brand-primary']}`,
      outlineOffset: '-3px',
    }),
    ':focus-visible': {
      ...$theme.focusOutline,
    },
  }),
);
